export default function() {
    $(".cat-pill:first").addClass("active");
    $(".videos-tab:first").addClass("fade show active");
    $(".caroussel-list:first").addClass("active");
    $(".sample-video:first").addClass("active");
}